<div class="flex-direction-column center-center gap-15 container-balao-sugestao" [style.min-height]="heigth" [style.width]="width">
  @if (titulo){
    <span class="font-24 weight-700" style="text-align: center">{{ titulo }}</span>
  }
  @if (texto){
    <span class="font-12 weight-400">{{ texto }}</span>
  }
</div>
